import About from "./components/About";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Servicios from "./components/Servicios";
import Footer from "./components/Footer";
import Features from "./components/Staff";



function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Features />
      <Servicios />
      <About />
      <Footer />

    </div>
  );
}

export default App;
